var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10167_18403)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10167_18403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0325 3.5118C20.0325 3.5118 19.6945 3.60757 19.1368 3.77657C19.041 3.4611 18.8945 3.10056 18.703 2.71186C18.0721 1.50068 17.1313 0.847207 16.0159 0.847207C15.9426 0.847207 15.8694 0.847206 15.7736 0.86974C15.7511 0.819039 15.7004 0.796506 15.6779 0.751438C15.1934 0.216266 14.5625 -0.0259696 13.8132 0.00219737C12.3598 0.0528979 10.9064 1.08944 9.74591 2.95409C8.92344 4.26104 8.2925 5.90599 8.12349 7.1904C6.45038 7.69741 5.2899 8.06358 5.26737 8.08611C4.42236 8.35088 4.39419 8.37905 4.29842 9.17336C4.22519 9.77613 2 26.8284 2 26.8284L20.3085 30V3.48927C20.1564 3.48927 20.0832 3.5118 20.0325 3.5118ZM15.7962 4.81875C14.8272 5.11168 13.7625 5.44969 12.7203 5.76516C13.0133 4.62721 13.5935 3.48927 14.2695 2.74002C14.5343 2.47526 14.9005 2.15979 15.3117 1.96262C15.7229 2.83579 15.8187 4.02444 15.7962 4.81875ZM13.8132 0.993674C14.1512 0.993674 14.4442 1.06691 14.6864 1.21338C14.2977 1.40491 13.909 1.72038 13.5485 2.08655C12.6302 3.07803 11.926 4.62721 11.6331 6.10879C10.7599 6.37356 9.88675 6.64396 9.09244 6.8862C9.62198 4.55398 11.5824 1.04437 13.8132 0.993674ZM11.0022 14.3166C11.0979 15.8658 15.1934 16.2038 15.4356 19.8599C15.6046 22.7442 13.909 24.7046 11.4641 24.8511C8.5122 25.0426 6.88978 23.3019 6.88978 23.3019L7.52072 20.6373C7.52072 20.6373 9.14314 21.871 10.4501 21.7753C11.2951 21.7246 11.6106 21.026 11.588 20.5415C11.4697 18.5079 8.1235 18.6262 7.90943 15.2856C7.71789 12.4745 9.55438 9.64093 13.6273 9.37616C15.199 9.28039 15.999 9.66909 15.999 9.66909L15.0807 13.1562C15.0807 13.1562 14.0386 12.6717 12.8048 12.7675C11.0022 12.8858 10.9796 14.0237 11.0022 14.3166ZM16.7651 4.53144C16.7651 3.80474 16.6693 2.76256 16.3313 1.88938C17.4468 2.10909 17.9763 3.3428 18.2185 4.09204C17.7848 4.21597 17.3003 4.36244 16.7651 4.53144ZM20.8606 29.9606L28.4657 28.0734C28.4657 28.0734 25.1983 5.96232 25.1701 5.81586C25.1476 5.66939 25.0237 5.57362 24.9054 5.57362C24.7871 5.57362 22.652 5.52292 22.652 5.52292C22.652 5.52292 21.3451 4.26104 20.8606 3.77657V29.9606Z",
    fill: "#95BF47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10167_18403",
    x: -18,
    y: -16,
    width: 66.4658,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10167_18403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10167_18403",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10167_18403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/Shopify.0738550861fea7cf6c13b9d64b5d9d90.svg";
export { ForwardRef as ReactComponent };